import type { JSX } from 'react';

import { FlyConsole } from '../../fly/Console';

/**
 * 飞行分区。
 *
 * 它是四个分区里唯一**自己占满高度、整页不滚**的：内容是操作台（姿态、操作条、地图、
 * 仪表），不是文档。滚动只发生在右侧栏内部。
 *
 * ## 为什么标题只剩下给读屏器的那一份
 *
 * 页面级 `<h1>飞行</h1>` 仍然必须存在：它是文档结构里的"这是什么页面"，
 * 也是测试与读屏器的稳定入口。但它**不再占用可见的垂直空间** ——
 * 顶部工具栏里那个高亮的"飞行"已经用更大的字号、更高的对比度说完了同一句话，
 * 而飞行分区每一像素高度都是姿态与地图的。可见标题在这种情况下不是"更清楚"，
 * 只是把同一句话说两遍并顺手拿走 40px。
 *
 * 原来的"后续接入"清单也一并去掉：它列的两项（地图与航迹、多机选择）里地图那项
 * 已经接上了，剩下的多机视图在待办里跟踪，比挂在飞行页上更不容易过期。
 */
export function FlySection(): JSX.Element {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <h1 className="sr-only">飞行</h1>
      <FlyConsole />
    </div>
  );
}
